"use strict";
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Logger = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _cloneDeep = _interopRequireDefault(require("clone-deep"));
var _deepmerge = _interopRequireDefault(require("deepmerge"));
var _nodePath = _interopRequireDefault(require("node:path"));
var _pino = require("pino");
var _pinoStdSerializers = _interopRequireDefault(require("pino-std-serializers"));
var _applicationInsights = require("./application-insights");
var _constants = require("./constants");
var _LoggerBrowserConfiguration = require("./internal/LoggerBrowserConfiguration");
var _formatError = require("./internal/formatError");
var _isPlainObject = require("./internal/isPlainObject");
var _loggerEventEmitter = require("./internal/loggerEventEmitter");
var _pinoBrowserRuntimeTransport = require("./internal/pino-runtime-transports/pinoBrowserRuntimeTransport");
var _printWarningWithTrace = require("./internal/printWarningWithTrace");
var _createMetadataTelemetryInitializer = require("./internal/telemetry/browser/createMetadataTelemetryInitializer");
var _SeverityLevels = require("./types/SeverityLevels");
var _Logger;
/* eslint-disable new-cap -- this is kind of enforced by Pino with the enum we have  */ var isInBrowserRuntime = typeof window !== 'undefined';
var isInNodeRuntime = !isInBrowserRuntime;
var loggerDebugIsEnabled = process.env.DEBUG_LOGGER === 'true';
var isTestingLogger = process.env.LOGGER_TEST === 'true';
var isDevelopment = process.env.NODE_ENV !== 'production';
var parentLoggerDefaultMessageMetadata = {};
var childLoggerDefaultMessageMetadata = {};
/**
 * Logger for Oriflame applications.
 *
 * @example
 *
 * #### Simple
 *
 * This will only print info to console:
 *
 * ```ts
 * // Setup should occur before any logging is done, but can be called after to update metadata globally
 * Logger.configure({
 *    // ...setup properties
 * });
 * // Create instance with desired name or any other configuration...
 * const myLogger = new Logger({ name: 'application' });
 * // ...and do the logging 🎉
 * myLogger.info('This is just info'); // => [application]: This is just info
 * // You can even attach useful information in object as a second parameter
 * myLogger.info('This is info with other information', { weather: '🌤️' }); // => [application]: This is info with other information { metadata: { weather:  '🌤️' } }
 * ```
 *
 * #### With metadata
 *
 * You can add something whats called 'metadata'. Either globally during setup or locally for Logger instance.
 * These metadata properties are added to each log output (formatting may differr)
 *
 * ```ts
 * // Add filters for your logging
 * Logger.updateConfiguration({
 *    filters: [
 *      forName: 'my-component',
 *      forSeverityLevel: SeverityLevels.DEBUG,
 *      // Let debug be always enabled for Logger with name 'my-component'
 *      enabled: true
 *   ]
 * })
 * // Create your instance
 * const myLogger = new Logger('my-component', { weather: '🌤️' });
 * // And log it to see the results
 * myLogger.info('Hello there'); // => [my-component]: Hello there { language: 'dk-DK', myProperty: { other: false }, metadata: { weather: '🌤️' } }
 * ```
 */ var Logger = /*#__PURE__*/ function() {
    function Logger(name, loggerMetadataOrAreaName, loggerMetadata) {
        _class_call_check(this, Logger);
        (0, _defineProperty2.default)(this, "name", void 0);
        (0, _defineProperty2.default)(this, "areaName", void 0);
        (0, _defineProperty2.default)(this, "pinoChild", null);
        (0, _defineProperty2.default)(this, "messageMetadata", (0, _cloneDeep.default)(childLoggerDefaultMessageMetadata));
        this.name = name;
        this.areaName = typeof loggerMetadataOrAreaName === 'string' ? loggerMetadataOrAreaName : undefined;
        var _ref, _ref1;
        this.messageMetadata = (_ref1 = (_ref = (typeof loggerMetadataOrAreaName === "undefined" ? "undefined" : _type_of(loggerMetadataOrAreaName)) === 'object' ? loggerMetadataOrAreaName : undefined) !== null && _ref !== void 0 ? _ref : loggerMetadata) !== null && _ref1 !== void 0 ? _ref1 : childLoggerDefaultMessageMetadata;
    }
    _create_class(Logger, [
        {
            // listen for localstorage updates without the need to reload the whole page
            /** Global logger localstorage listener */ /**
   * Creates child Logger instance that describes more specific area
   * Is equivalent of `new Logger('<name>', <areaName>, ...)`
   */ key: "createChild",
            value: function createChild(areaName) {
                var incommingChildMetadata = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return new Logger(this.name, areaName, // Copy parent metadata
                (0, _deepmerge.default)(childLoggerDefaultMessageMetadata, incommingChildMetadata));
            }
        },
        {
            key: "initializeChild",
            value: function initializeChild() {
                var _this = this;
                var parent = Logger.getPinoParent();
                var setupOptions = {};
                // Name should not part of message during production
                if (isDevelopment) {
                    var name = [
                        this.name,
                        this.areaName
                    ].filter(Boolean).join(' > ');
                    setupOptions.msgPrefix = "[".concat(name, "] ");
                }
                if (parent) {
                    this.pinoChild = parent.child(// due to internal logic we have set this as empty object
                    // as we create custom message with properties on each message
                    // This is so that we can change properties
                    {}, setupOptions);
                }
                // Logger reset for tests
                if (isTestingLogger) {
                    _loggerEventEmitter.loggerEventEmitter.addListener('reset', function() {
                        _this.pinoChild = null;
                        // This is so that reset works correctly, normally this.childSetupOptions.bindings won't be used anymore
                        // after Logger was initialized
                        _this.messageMetadata = (0, _cloneDeep.default)(childLoggerDefaultMessageMetadata);
                    });
                }
            }
        },
        {
            key: "getPinoChild",
            value: function getPinoChild() {
                if (!this.pinoChild) {
                    this.initializeChild();
                }
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- should be initialized by now
                return this.pinoChild;
            }
        },
        {
            key: "createPinoMessage",
            value: function createPinoMessage(message, additionalMeta) {
                var metadata = (0, _deepmerge.default)(this.messageMetadata, additionalMeta !== null && additionalMeta !== void 0 ? additionalMeta : {}, {
                    isMergeableObject: _isPlainObject.isPlainObject
                });
                var teamName = metadata.teamName, metadataWithoutTeamName = _object_without_properties(metadata, [
                    "teamName"
                ]);
                // Ordering matters!
                var result = _object_spread(_object_spread_props(_object_spread({}, message, Logger.globalMetadata), {
                    name: this.name
                }), this.areaName && {
                    areaName: this.areaName
                }, teamName != null && {
                    teamName: teamName
                }, Object.keys(metadataWithoutTeamName).length > 0 && {
                    metadata: metadataWithoutTeamName
                });
                if (_applicationInsights.ApplicationInsights.isInitialized() && (0, _applicationInsights.isServerApplicationInsightsClient)(_applicationInsights.ApplicationInsights.get())) {
                    var ai = _applicationInsights.ApplicationInsights.getForServer();
                    // What a weird typing they have!
                    var context = ai.getCorrelationContext();
                    var operation = (context !== null && context !== void 0 ? context : {}).operation;
                    var _ref = operation !== null && operation !== void 0 ? operation : {}, id = _ref.id, name = _ref.name, parentId = _ref.parentId;
                    if (operation) {
                        result = _object_spread_props(_object_spread({}, result), {
                            applicationInsightsOperation: {
                                id: id,
                                name: name,
                                parentId: parentId
                            }
                        });
                    }
                }
                return result;
            }
        },
        {
            /**
   * Method for logging error
   *
   * @example
   *
   * #### Usage if you want to log error as is
   * ```js
   * const error = new Error('Some error message');
   * new Logger('@ori/awesome').error(error);
   * ```
   *
   * #### Usage if you want to give error additional description
   * ```js
   * const someOtherError = new Error('This is some specific error');
   * const error = new Error(
   *    // Here describe someOtherError in more detail
   *    'Some error message',
   *    {
   *      // You give previous error here
   *      cause: someOtherError,
   *    }
   * );
   * new Logger('@ori/awesome').error(error);
   * ```
   */ key: "error",
            value: function error(error) {
                var metadata = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var message = error.message, cause = error.cause;
                var causeMessage = // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- we need to verify runtime value first
                cause && (typeof cause === 'string' || cause instanceof Error) ? cause instanceof Error ? cause.message : cause : undefined;
                var pinoMessage = this.createPinoMessage({
                    error: (0, _formatError.formatError)(error)
                }, metadata);
                this.getPinoChild().ERROR(pinoMessage, // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- we need to use || for empty strings
                message || causeMessage || 'An error happened');
            }
        },
        {
            /**
   * Method for logging metric
   *
   * @example Logging the speed of a function call
   * ```js
   *
   * ```
   */ key: "metric",
            value: function metric(name, value) {
                var metadata = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var pinoMessage = this.createPinoMessage({
                    metricName: name,
                    metricValue: value
                }, metadata);
                this.getPinoChild().METRIC(pinoMessage, 'Collected metric with the name "'.concat(name, '" and value "').concat(value, '"'));
            }
        },
        {
            /**
   * Logs info
   */ key: "info",
            value: function info(message) {
                var metadata = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var pinoMessage = this.createPinoMessage({}, metadata);
                this.getPinoChild().INFO(pinoMessage, message);
            }
        },
        {
            /**
   * Logs debug and is ommited in production mode
   */ key: "debug",
            value: function debug(message) {
                var metadata = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var pinoMessage = this.createPinoMessage({}, metadata);
                this.getPinoChild().DEBUG(pinoMessage, message);
            }
        },
        {
            /**
   * Logs warning
   */ key: "warn",
            value: function warn(message) {
                var metadata = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var pinoMessage = this.createPinoMessage({}, metadata);
                this.getPinoChild().WARN(pinoMessage, message);
            }
        },
        {
            /**
   * Sets new metadata object to this Logger instance.
   */ key: "setMetadata",
            value: function setMetadata(metadata) {
                this.getPinoChild().setBindings(metadata);
                return this;
            }
        },
        {
            /**
   * Takes newly provided metadata and merges it with previously defined metadata on this Logger instance
   */ key: "updateMetadata",
            value: function updateMetadata(metadata) {
                var child = this.getPinoChild();
                this.setMetadata((0, _deepmerge.default)(child.bindings(), metadata, {
                    isMergeableObject: _isPlainObject.isPlainObject
                }));
                return this;
            }
        }
    ], [
        {
            key: "globalMetadata",
            get: /**
   *  Gets global metadata. If executed in Node.js environment, it will also include metadata from AsyncLocalStorage.
   * @returns Global metadata
   */ function get() {
                if (isInNodeRuntime) {
                    // eslint-disable-next-line node/global-require, @typescript-eslint/no-require-imports -- caller is not async
                    var asyncLocalStorage = require('./server/asyncLocalStorage').asyncLocalStorage;
                    var storedMetadata = asyncLocalStorage.getStore();
                    if (storedMetadata) {
                        // if false, we have no defined store
                        this._globalMetadata = storedMetadata;
                    }
                }
                return (0, _deepmerge.default)(parentLoggerDefaultMessageMetadata, this._globalMetadata, {
                    isMergeableObject: _isPlainObject.isPlainObject
                });
            },
            set: /**
   * Overrides global metadata with new set of metadata
   */ function set(metadata) {
                this._globalMetadata = metadata;
                // If we are in Node.js environment we need to update AsyncLocalStorage as well
                if (isInNodeRuntime) {
                    // eslint-disable-next-line node/global-require, @typescript-eslint/no-require-imports -- caller is not async
                    var asyncLocalStorage = require('./server/asyncLocalStorage').asyncLocalStorage;
                    var storedMetadata = asyncLocalStorage.getStore();
                    if (storedMetadata) {
                        // Assign metadata without changing the reference of the store object
                        Object.assign(storedMetadata, this._globalMetadata);
                    }
                }
                // If we are in browser and Application Insights is initialized, we need to update the metadata for dependencies
                if (isInBrowserRuntime && _applicationInsights.ApplicationInsights.isInitialized()) {
                    var _this_metadataDependencyInitializer;
                    (_this_metadataDependencyInitializer = this.metadataDependencyInitializer) !== null && _this_metadataDependencyInitializer !== void 0 ? _this_metadataDependencyInitializer : this.metadataDependencyInitializer = (0, _createMetadataTelemetryInitializer.createMetadataTelemetryInitializer)(_applicationInsights.ApplicationInsights.getForClient());
                    this.metadataDependencyInitializer(this._globalMetadata);
                }
            }
        },
        {
            key: "setGlobalMetadata",
            value: function setGlobalMetadata(metadata) {
                this.globalMetadata = metadata;
            }
        },
        {
            key: "updateGlobalMetadata",
            value: /**
   * Updates global metadata with provided metadata. Metadata that are provided will just be merged with already set metadata
   */ function updateGlobalMetadata(metadata) {
                this.globalMetadata = (0, _deepmerge.default)(this.globalMetadata, (0, _cloneDeep.default)(metadata), {
                    isMergeableObject: _isPlainObject.isPlainObject
                });
            }
        },
        {
            key: "isInitialized",
            value: function isInitialized() {
                return !!this.pinoParent;
            }
        },
        {
            key: "trackPageView",
            value: /**
   * Tracks `pageView` manually.
   * Automatic `pageView` tracking in Application Insights is disabled to prevent `pageView` from being sent multiple times.
   * Can be called on the client and Application Insights must be already initialized.
   */ function trackPageView() {
                if (isInBrowserRuntime && !this.isPageViewTracked && _applicationInsights.ApplicationInsights.isInitialized()) {
                    _applicationInsights.ApplicationInsights.getForClient().trackPageView({
                        properties: {
                            TRACK_THIS_PAGE_VIEW: _constants.TRACK_THIS_PAGE_VIEW
                        }
                    });
                    this.isPageViewTracked = true;
                }
            }
        },
        {
            key: "initializeConfiguration",
            value: /** Initializes configuration  */ function initializeConfiguration() {
                // Initialize configuration for browser
                if (isInBrowserRuntime) {
                    // Read initial configuration
                    var currentBrowserConfiguration = _LoggerBrowserConfiguration.LoggerBrowserConfiguration.get();
                    if (currentBrowserConfiguration) {
                        // Set here is kind of intentional. This is so the localStorage is last to be applied
                        this.setConfiguration(currentBrowserConfiguration);
                    }
                    window.addEventListener('storage', this.localStorageListener);
                }
            }
        },
        {
            key: "withPinoConfigurationNodeTransports",
            value: function withPinoConfigurationNodeTransports(options) {
                // eslint-disable-next-line no-param-reassign -- no need to clone that
                options.transport = {
                    pipeline: [
                        {
                            target: isTestingLogger ? _nodePath.default.join(__dirname, 'internal/pino-runtime-transports/pinoNodeRuntimeTransport.ts') : require.resolve('./internal/pino-runtime-transports/pinoNodeRuntimeTransport'),
                            options: {
                                loggerConfiguration: this.getConfiguration(),
                                applicationInsightsConfiguration: global.oriAppInsightsSettings
                            }
                        }
                    ]
                };
                return options;
            }
        },
        {
            key: "withPinoConfigurationBrowserTransports",
            value: function withPinoConfigurationBrowserTransports(options) {
                var handler = (0, _pinoBrowserRuntimeTransport.pinoBrowserRuntimeTransport)({
                    loggerConfiguration: this.getConfiguration(),
                    applicationInsightsConfiguration: global.oriAppInsightsSettings
                });
                // eslint-disable-next-line no-param-reassign -- no need to clone that
                options.browser = {
                    write: function(pinoMessage) {
                        return handler(pinoMessage);
                    }
                };
                return options;
            }
        },
        {
            key: "initializeParent",
            value: /** Initilizes Pino */ function initializeParent() {
                var _this = this;
                this.initializeConfiguration();
                var pinoOptions = {
                    useOnlyCustomLevels: true,
                    customLevels: _SeverityLevels.SeverityLevels,
                    // IMPORTANT: This has to remain as the lowest possible level in the SeverityLevels enum
                    level: 'DEBUG',
                    serializers: {
                        // This is for environments that uses worker threads - currently only Node.js
                        // Worker threads are known to not retain original prototypes and
                        // only copies serializable values (anything that is enurable)
                        error: _pinoStdSerializers.default.errWithCause
                    }
                };
                if (isInNodeRuntime) {
                    pinoOptions = this.withPinoConfigurationNodeTransports(pinoOptions);
                } else {
                    pinoOptions = this.withPinoConfigurationBrowserTransports(pinoOptions);
                }
                this.pinoParent = (0, _pino.pino)(pinoOptions);
                if (loggerDebugIsEnabled) {
                    (0, _printWarningWithTrace.printWarningWithTrace)('Logger was initialized!');
                }
                // Logger reset for tests
                if (isTestingLogger) {
                    _loggerEventEmitter.loggerEventEmitter.addListener('reset', function() {
                        _this.pinoParent = null;
                        _this._globalMetadata = (0, _cloneDeep.default)(parentLoggerDefaultMessageMetadata);
                    });
                }
            }
        },
        {
            key: "getPinoParent",
            value: function getPinoParent() {
                if (!this.isInitialized()) {
                    this.initializeParent();
                }
                return this.pinoParent;
            }
        },
        {
            key: "setConfiguration",
            value: /** Sets configuration for logger */ function setConfiguration(nextConfiguration) {
                // Merge with default, because the defaults must be always present
                this.configuration = (0, _deepmerge.default)(_constants.defaultLoggerConfiguration, nextConfiguration);
                _loggerEventEmitter.loggerEventEmitter.emit('configurationUpdated', this.configuration);
            }
        },
        {
            key: "updateConfiguration",
            value: /** takes new configuration and merges it with existing */ function updateConfiguration(nextConfiguration) {
                this.setConfiguration((0, _deepmerge.default)(this.configuration, nextConfiguration));
            }
        },
        {
            key: "getConfiguration",
            value: /** Gets current configuration for logger */ function getConfiguration() {
                return this.configuration;
            }
        },
        {
            key: "isTransportConfigured",
            value: function isTransportConfigured(transportType) {
                return this.configuration.enabled && this.configuration.filters.some(function(filter) {
                    return filter.enabled && filter.byTransportType === transportType;
                });
            }
        },
        {
            key: "flush",
            value: function flush() {
                if (isInNodeRuntime) {
                    var parent = this.getPinoParent();
                    if (parent) {
                        parent.flush();
                    }
                }
            }
        }
    ]);
    return Logger;
}();
// Setup helper Logger methods for browser
exports.Logger = Logger;
_Logger = Logger;
(0, _defineProperty2.default)(Logger, "pinoParent", null);
(0, _defineProperty2.default)(Logger, "isPageViewTracked", false);
(0, _defineProperty2.default)(Logger, "configuration", (0, _cloneDeep.default)(_constants.defaultLoggerConfiguration));
(0, _defineProperty2.default)(Logger, "metadataDependencyInitializer", null);
// backing field for globalMetadata, do not access directly
(0, _defineProperty2.default)(Logger, "_globalMetadata", (0, _cloneDeep.default)(parentLoggerDefaultMessageMetadata));
(0, _defineProperty2.default)(Logger, "localStorageListener", function() {
    var currentBrowserConfiguration = _LoggerBrowserConfiguration.LoggerBrowserConfiguration.get();
    if (currentBrowserConfiguration) {
        _Logger.setConfiguration(currentBrowserConfiguration);
    }
});
if (isInBrowserRuntime) {
    var _window, _window_ori;
    var _ori;
    (_ori = (_window = window).ori) !== null && _ori !== void 0 ? _ori : _window.ori = {};
    var _logger;
    (_logger = (_window_ori = window.ori).logger) !== null && _logger !== void 0 ? _logger : _window_ori.logger = {
        getConfiguration: Logger.getConfiguration,
        setConfiguration: _LoggerBrowserConfiguration.LoggerBrowserConfiguration.set,
        updateConfiguration: _LoggerBrowserConfiguration.LoggerBrowserConfiguration.update
    };
} //# sourceMappingURL=Logger.js.map
